import { createRouter, createWebHashHistory } from 'vue-router';
import layout from '../views/layout/index.vue';
const routes = [
    {
        path: '/',
        name: 'home',
        component: layout,
        redirect: '/new-chat',
        children: [
            {
                // AI对话
                path: '/new-chat',
                name: '/new-chat',
                component: () => import('../views/subview/new-chat/new-chat.vue')
            },
            {
                // AI写作
                path: '/writing',
                name: '/writing',
                meta: {
                    labe: 'AI写作',
                    type: 'writing'
                },
                component: () => import('../views/subview/writing/writing.vue')
            },
            {
                // 性格测试
                path: '/mbti',
                name: '/mbti',
                component: () => import('../views/subview/mbti/mbti.vue')
            },
            {
                // AI翻译
                path: '/translate',
                name: '/translate',
                component: () => import('../views/subview/translate/translate.vue')
            },
            {
                // 最近对话
                path: '/history-chat',
                name: '/history-chat',
                meta: {
                    labe: '历史对话',
                    is_login: true
                },
                component: () => import('../views/subview/history-chat/history-chat.vue')
            },
            {
                // 对话
                path: '/chat',
                name: '/chat',
                meta: {
                    labe: '',
                    is_login: true
                },
                component: () => import('../views/subview/chat/chat.vue')
            },
            {
                // 对话
                path: '/drawing_chat',
                name: '/drawing_chat',
                meta: {
                    labe: '',
                    is_login: true,
                    // type: 'drawing'
                },
                component: () => import('../views/subview/drawing/drawing_chat/drawing_chat.vue')
            },
            {
                // 对话
                path: '/drawing',
                name: '/drawing',
                meta: {
                    labe: '',
                    type: 'drawing'
                },
                component: () => import('../views/subview/drawing/drawing.vue')
            },
            {
                // 音乐生成
                path: '/music',
                name: '/music',
                component: () => import('../views/subview/music/music.vue')
            },
            {
                // ppt生成
                path: '/ppt',
                name: '/ppt',
                component: () => import('../views/ppt/index.vue'),
                redirect: '/pptMake',
                children: [
                    {
                        // 首页
                        path: '/pptMake',
                        name: '/pptMake',
                        meta: {
                            labe: 'PPT制作',
                            type: 'ppt'
                        },
                        component: () => import('../views/ppt/home/home.vue')
                    },
                    {
                        // 大纲
                        path: '/outline',
                        name: '/outline',
                        meta: {
                            labe: 'PPT大纲',
                            is_login: true,
                            type: 'ppt'
                        },
                        component: () => import('../views/ppt/outline/outline.vue')
                    },
                    {
                        // 主题模版
                        path: '/stencilTheme',
                        name: '/stencilTheme',
                        meta: {
                            labe: 'PPT模版',
                            is_login: true,
                            type: 'ppt'
                        },
                        component: () => import('../views/ppt/stencilTheme/stencilTheme.vue')
                    },
                    {
                        // 预览
                        path: '/preview',
                        name: '/preview',
                        meta: {
                            labe: 'PPT预览',
                            is_login: true,
                            // type: 'ppt'
                        },
                        component: () => import('../views/ppt/preview/preview.vue')
                    }
                ]
            },
            {
                // 智能体
                path: '/intelligence',
                name: '/intelligence',
                meta: {
                    labe: '智能体'
                },
                component: () => import('../views/subview/intelligence/intelligence.vue'),
                redirect: '/intelligence_list',
                children: [
                    {
                        // 智能体列表
                        path: '/intelligence_list',
                        name: '/intelligence_list',
                        meta: {
                            labe: '选择智能体',
                            is_login: false
                        },
                        component: () => import('../views/subview/intelligence/intelligence_list/intelligence_list.vue')
                    },
                    {
                        // 智能体-新对话
                        path: '/intelligence_chat',
                        name: '/intelligence_chat',
                        meta: {
                            labe: '新对话',
                            is_login: true
                        },
                        component: () => import('../views/subview/intelligence/intelligence_chat/intelligence_chat.vue')
                    },
                    {
                        // 智能体-文件转换
                        path: '/intelligence_fileConversion',
                        name: '/intelligence_fileConversion',
                        meta: {
                            labe: '新对话',
                            is_login: true
                        },
                        component: () => import('../views/subview/intelligence/intelligence_fileConversion/intelligence_fileConversion.vue')
                    }
                ]
            },
            {
                // 图像理解
                path: '/imagecomprehend',
                name: '/imagecomprehend',
                meta: {
                    labe: '图像理解'
                },
                component: () => import('../views/subview/imagecomprehend/imagecomprehend.vue')
            },
            {
                // 语音通话
                path: '/voicecall',
                name: '/voicecall',
                meta: {
                    labe: '语音通话',
                    is_login: true
                },
                component: () => import('../views/subview/voicecall/voicecall.vue')
            },
            {
                // 语音通话
                path: '/voicecallChat',
                name: '/voicecallChat',
                meta: {
                    labe: '语音通话',
                    is_login: true
                },
                component: () => import('../views/subview/voicecall/voicecallChat.vue')
            },
            {
                // deepseek
                path: '/deepseek',
                name: '/deepseek',
                meta: {
                    labe: 'deepseek',
                    is_login: true
                },
                component: () => import('../views/subview/deepseek/deepseek.vue')
            },
            {
                // 九天大模型
                path: '/nineHeavens',
                name: '/nineHeavens',
                meta: {
                    labe: '九天大模型',
                    is_login: true
                },
                component: () => import('../views/subview/nineHeavens/nineHeavens.vue')
            },
            {
                // 设置
                path: '/setting',
                name: '/setting',
                meta: {
                    labe: '设置',
                    is_login: true
                },
                component: () => import('../views/subview/setting/setting.vue')
            },
            {
                // AI会议
                path: '/meeting',
                redirect: '/meeting/introduce',
                children: [
                    // AI会议-入口页
                    {
                        path: '/meeting/introduce',
                        name: '/meeting/introduce',
                        meta: {
                            labe: 'AI会议',
                            is_login: false,
                            type: 'meeting'
                        },
                        component: () => import('../views/subview/meeting/meeting_introduce/meeting_introduce.vue')
                    },
                    // AI会议-会议室
                    {
                        path: '/meeting/room',
                        name: '/meeting/room',
                        meta: {
                            labe: 'AI会议',
                            is_login: false,
                            type: 'meeting'
                        },
                        component: () => import('../views/subview/meeting/meeting_room/meeting_room.vue')
                    },
                    // AI会议-选择语言
                    {
                        path: '/meeting/selectLang',
                        name: '/meeting/selectLang',
                        meta: {
                            labe: 'AI会议',
                            is_login: false,
                            type: 'meeting'
                        },
                        component: () => import('../views/subview/meeting/meeting_selectLang/meeting_selectLang.vue')
                    },
                    // AI会议-音频转文字
                    {
                        path: '/meeting/audioToText',
                        name: '/meeting/audioToText',
                        meta: {
                            labe: '音视频转文字',
                            is_login: false,
                            type: 'meeting'
                        },
                        component: () => import('../views/subview/meeting/meeting_audioToText/meeting_audioToText.vue')
                    },
                    // AI会议-详情
                    {
                        path: '/meeting/detail',
                        name: '/meeting/detail',
                        meta: {
                            labe: 'AI会议',
                            is_login: false
                        },
                        component: () => import('../views/subview/meeting/meeting_detail/meeting_detail.vue')
                    },
                ]
            },
            {
                // 同声传译
                path: '/simultaneousTranslation',
                meta: {},
                redirect: '/simultaneousTranslation/introduce',
                children: [{
                        path: '/simultaneousTranslation/introduce',
                        name: '/simultaneousTranslation/introduce',
                        meta: {
                            labe: '同声传译',
                            is_login: false,
                            type: 'simultaneousTranslation'
                        },
                        component: () => import('../views/subview/simultaneousTranslation/simultaneousTranslation_introduce/simultaneousTranslation_introduce.vue')
                    }, {
                        path: '/simultaneousTranslation/generate',
                        name: '/simultaneousTranslation/generate',
                        meta: {
                            labe: '同声传译',
                            is_login: false,
                            type: 'simultaneousTranslation'
                        },
                        component: () => import('../views/subview/simultaneousTranslation/simultaneousTranslation_generate/simultaneousTranslation_generate.vue')
                    }]
            },
            {
                path: '/toPicture',
                name: '/toPicture',
                meta: {
                    labe: '图生图',
                    is_login: true,
                    // type: 'drawing'
                },
                component: () => import('../views/subview/toPicture/toPicture.vue')
            },
            {
                path: '/chuangkit',
                name: '/chuangkit',
                meta: {
                    labe: '创客贴',
                    is_login: true
                },
                component: () => import('../views/subview/chuangkit/chuangkit.vue')
            },
            {
                path: '/privacy',
                name: '/privacy',
                meta: {
                    labe: ''
                },
                component: () => import('../views/subview/privacy/privacy.vue')
            },
            {
                path: '/tabulation',
                name: '/tabulation',
                meta: {
                    labe: 'AI表格'
                },
                component: () => import('../views/subview/tabulation/tabulation.vue')
            }
        ]
    },
    {
        // 预览
        path: '/previewApp',
        name: '/previewApp',
        meta: {
            labe: '预览',
            is_login: true
        },
        component: () => import('../views/ppt/preview/preview_app.vue')
    }
];
const router = createRouter({
    history: createWebHashHistory(),
    routes
});
import config from '../api/config';
import store from '../store/index';
// 全局导航守卫
import emitter from '../utils/eventBus';
import feedback from '@/utils/feedback';
router.beforeEach(async (to, from, next) => {
    var _a, _b, _c, _d;
    if (to.path === '/previewApp') {
        return next();
    }
    if ((_a = to === null || to === void 0 ? void 0 : to.query) === null || _a === void 0 ? void 0 : _a.device_id) {
        localStorage.setItem('device_id', ((_b = to === null || to === void 0 ? void 0 : to.query) === null || _b === void 0 ? void 0 : _b.device_id) || '');
    }
    emitter.emit('closeMusic');
    // 网站路径名称
    if ((_c = to.meta) === null || _c === void 0 ? void 0 : _c.label) {
        document.title = to.meta.label;
    }
    else {
        document.title = config.brand_name; // 默认的title
    }
    // 访问路径不属于当前系统，则打开首页
    if (to.matched.length == 0)
        return next('/');
    // 判断是否在ppt路由内
    if (to.meta.type !== 'ppt') {
        localStorage.setItem('pptKeyword', '');
    }
    let status = await feedback.routeTips('route', from.name, to.name);
    if (status)
        return next(from.fullPath);
    if (!status && to.name === '/intelligence_chat' && from.name === '/intelligence_chat' && store.state.intelligenceStatus) {
        emitter.emit('intelligenceSwtich');
    }
    // 判断权限 非首页
    if (to.path !== '/' && to.path !== '/new-chat') {
        // 判断受限情况下，原路返回
        const token = localStorage.getItem('token');
        if (!token && ((_d = to.meta) === null || _d === void 0 ? void 0 : _d.is_login)) {
            store.commit('setLoginStatus', { status: true });
            return next(from.fullPath);
        }
        return next();
    }
    return next();
});
export default router;
